import { render, staticRenderFns } from "./WorkforceRegister.vue?vue&type=template&id=2e475f33&"
import script from "./WorkforceRegister.vue?vue&type=script&lang=js&"
export * from "./WorkforceRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports